<mat-paginator
	class="pag"
	[length]="pageEvent.length"
	[pageSize]="pageEvent.pageSize"
	[pageIndex]="pageEvent.pageIndex"
	[pageSizeOptions]="pageSizeOptions"
	(page)="paginationChanged($event)"
>
</mat-paginator>
